import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import Modal from '../../commonComponents/util/Modal';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import WarningModal from '../../commonComponents/shared/WarningModal';

const initialState = {
    selectedParticipantsIds: [],
    error: false,
    checkCampaignRules: true,
    showModals: {
        campaign60DayRuleAlertModal: false,
        campaignAddToActiveRuleAlertModal: false
    }
};

export default class PendingParticipantsModal extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.onClose = this.onClose.bind(this);
    }

    async onSubmit(addToActiveCampaign) {
        this.setState({ error: false });

        await this.props.addParticipants(!this.state.checkCampaignRules, this.state.selectedParticipantsIds, addToActiveCampaign);

        if (this.props.success) {
            this.onClose();
        } else {
            if (this.state.checkCampaignRules && this.props.message && (this.props.message.indexOf("60 days") >= 0 || this.props.message.indexOf("active campaigns") >= 0)) {
                this.toggleModal(this.props.message.indexOf("active campaigns") >= 0 ? 'campaignAddToActiveRuleAlertModal' : 'campaign60DayRuleAlertModal');
            } else {
                this.setState({ error: true });
            }
        }
    }

    onClose() {
        this.props.close();
        this.setState(initialState);
    }

    toggleSelection(id, event) {
        const selection = id === 'all'
            ? (event.target.checked ? this.props.pendingParticipants.data.filter(p => !p.incomplete).map(p => p.applicantId) : [])
            : (event.target.checked ? [...this.state.selectedParticipantsIds, id] : this.state.selectedParticipantsIds.filter(i => i !== id));
        this.setState({
            selectedParticipantsIds: selection
        });
    }

    render() {
        return (
            <div>
                <Modal modalShowing={this.props.show}>
                    <div className="modal-container">
                        <div className="modal add-pending-participants-modal xl-modal">
                            <div className="modal-header">
                                <div>
                                    <h4 className="page-header">{this.props.campaignListName}</h4>
                                    <p className="medium-text">{this.props.pendingParticipantsCount} Add Pending Participants</p>
                                </div>
                                <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                            </div>

                            <div className="modal-section table-container">
                                {this.props.pendingParticipants.success ?
                                    (this.props.pendingParticipants.loading ? <LoadingSpinner height="20" />
                                        : <table className="table">
                                            <thead>
                                                <tr className="table-header table-row">
                                                    <th>
                                                        {this.props.pendingParticipants.data.filter(p => !p.incomplete).length > 0 && <div className="custom-check-container">
                                                            <input type="checkbox" id="pending-select-all" className="custom-check"
                                                                onChange={this.toggleSelection.bind(this, 'all')}
                                                                checked={this.state.selectedParticipantsIds.length === this.props.pendingParticipants.data.filter(p => !p.incomplete).length} />
                                                            <label htmlFor="pending-select-all" className="secondary-text" title="Select All" />
                                                        </div>}
                                                    </th>
                                                    <th>Name</th>
                                                    <th>Address</th>
                                                    <th>Phone</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.props.pendingParticipants.data.map(participant => <HoverTableRow key={participant.applicantId}
                                                        onClick={() => this.pushRoute(`/recipient-accounts/${participant.applicantId}`)}>
                                                        <td>
                                                            <div className="custom-check-container">
                                                                <input type="checkbox" id={`participant-${participant.applicantId}`} className="custom-check input"
                                                                    onChange={this.toggleSelection.bind(this, participant.applicantId)}
                                                                    checked={this.state.selectedParticipantsIds.indexOf(participant.applicantId) >= 0}
                                                                    disabled={participant.incomplete} />
                                                                <label htmlFor={`participant-${participant.applicantId}`} className="secondary-text input"
                                                                    title="Cannot add incomplete recipient" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Link to={`/recipient-accounts/${participant.applicantId}`}>
                                                                {participant.name}
                                                            </Link>
                                                            {participant.incomplete && <span className="tag incomplete">Incomplete</span>}
                                                        </td>
                                                        <td>{participant.address}</td>
                                                        <td>{participant.phoneNumber.join(", ")}</td>
                                                    </HoverTableRow>)
                                                }
                                            </tbody>
                                        </table>) :
                                    <span className="error-message">Something went wrong and we could not retreive the pending participants for {this.props.campaignListName} list.
                                        Please try again.</span>}
                            </div>

                            {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                                <div className="modal-btns text-right">
                                    <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                    <button className="btn btn-primary" disabled={!this.state.selectedParticipantsIds.length}
                                        onClick={() => this.onSubmit(false)}>Submit</button>
                                    <FadeOutErrorMessage show={this.state.error} message={this.props.message} />
                                </div>}
                        </div>
                    </div>
                </Modal>

                <WarningModal
                    show={this.state.showModals.campaign60DayRuleAlertModal}
                    close={this.toggleModal.bind(this, "campaign60DayRuleAlertModal")}
                    message={this.props.message}
                    continue={() => {
                        this.setState({ checkCampaignRules: false }, () => this.onSubmit(false));
                    }} />

                <WarningModal
                    show={this.state.showModals.campaignAddToActiveRuleAlertModal}
                    close={this.toggleModal.bind(this, "campaignAddToActiveRuleAlertModal")}
                    message={this.props.message}
                    confirmationMessage={"Do you want to add these participant(s) to these campaign(s)?"}
                    cancelText={"No"}
                    continueText={"Yes"}
                    cancel={() => {
                        this.setState({ checkCampaignRules: false }, () => this.onSubmit(false));
                    }}
                    continue={() => {
                        this.setState({ checkCampaignRules: false }, () => this.onSubmit(true));
                    }} />

            </div >
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/PendingParticipantsModal.jsx